import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {setAudio} from "../store/audio/action";
import {env} from "../env";
import {pfType999} from "../constants/general";
import kpwMute from "../assets/images/audio/mute_red.svg";
import kpwVolume from "../assets/images/audio/volume_red.svg";
import mute from "../assets/images/audio/mute_sky.svg";
import volume from "../assets/images/audio/volume_sky.svg";
import muteWhite from "../assets/images/audio/mute_white.svg";
import volumeWhite from "../assets/images/audio/volume_white.svg";
import muteBlue from "../assets/images/audio/mute_blue.svg";
import volumeBlue from "../assets/images/audio/volume_blue.svg";

const SoundToggle = ({
                         className = "",
                         width = 30,
                         style = {},
                         hidden = false,
                         isMobile = false,
                         isDanger = false,
                         isBlue = false
                     }) => {
    const dispatch = useDispatch();
    const isMute = useSelector((state) => state.audio?.isMute);
    const platformType = env.PLATFORM_TYPE;

    const icon = useMemo(() => {
        if (pfType999) {
            return isMute ? muteWhite : volumeWhite;
        }

        if (platformType === "KPW") {
            return isMute ? kpwMute : kpwVolume;
        }

        return isMute ? mute : volume;
    }, [isMute, platformType]);

    const getIcon = useMemo(() => {
        if (!isMobile) return icon;

        if (isDanger) {
            return isMute ? kpwMute : kpwVolume;
        }

        if (isBlue) {
            return isMute ? muteBlue : volumeBlue;
        }

        return isMute ? muteWhite : volumeWhite;

    }, [isMute, isMobile, icon, isDanger, isBlue]);

    if (hidden) {
        return null;
    }

    return (
        <img
            alt={isMute ? "Muted" : "Sound on"}
            onClick={() => dispatch(setAudio())}
            width={width}
            className={`sound-toggle ${className}`.trim()}
            style={{cursor: "pointer", ...style}}
            src={getIcon}
        />
    );
};

SoundToggle.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
    hidden: PropTypes.bool
};

export default SoundToggle;
